import {
  SIDE_LOADED_DATA_SET_TEMPLATE_FILENAME,
  SideLoadedDataSetTemplateColumns,
} from "constants/sideLoadedDataSets";

import { downloadFileBlob } from "lib";

export function buildSideLoadedDataSetTemplate(): string {
  return `${SideLoadedDataSetTemplateColumns.join(",")}\n`;
}

export function downloadSideLoadedDataSetTemplate(): void {
  downloadFileBlob(
    SIDE_LOADED_DATA_SET_TEMPLATE_FILENAME,
    new Blob([buildSideLoadedDataSetTemplate()], {
      type: "text/csv;charset=utf-8;",
    }),
  );
}
